import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ExitIcon, Logo } from "@vfit/ui/icons";
import * as S from "./fullScreenModalExtended.style";
export var FullScreenModalExtended = function(param) {
    var children = param.children, show = param.show, onCloseModal = param.onCloseModal, _showIcon = param.showIcon, showIcon = _showIcon === void 0 ? true : _showIcon, _showLogo = param.showLogo, showLogo = _showLogo === void 0 ? false : _showLogo;
    if (!show) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(S.Background, {
        children: [
            showLogo && /*#__PURE__*/ _jsx(S.LogoWrapper, {
                children: /*#__PURE__*/ _jsx(Logo, {})
            }),
            /*#__PURE__*/ _jsx(S.Container, {
                children: /*#__PURE__*/ _jsx(S.ModalContent, {
                    className: "modalContent",
                    children: /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            showIcon && /*#__PURE__*/ _jsx(S.IconWrap, {
                                role: "button",
                                tabIndex: 0,
                                onClick: onCloseModal,
                                onKeyDown: onCloseModal,
                                children: /*#__PURE__*/ _jsx(ExitIcon, {})
                            }),
                            children
                        ]
                    })
                })
            })
        ]
    });
};
